import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import PanDulce from "../../images/pan-dulce.jpeg";
import Pepas from "../../images/pepas.jpeg";
import Pan from "../../images/pan.jpeg";

const Container = tw.div`relative -mx-8 -mt-8`;
const ContainerGrid = tw.div`grid grid-cols-1 md:grid-cols-2 gap-8 items-center p-8 bg-white`;
const Content = tw.div`mx-auto py-20 lg:py-24`;
const TextSection = tw.div`space-y-4 mx-auto`;
const Subtitle = tw.h3`text-sm font-bold text-gray-600 uppercase`;
const Paragraph = tw.p`text-gray-700 leading-relaxed`;

const LinksWrapper = tw.div`flex gap-4 flex-wrap`;
const RecipeLink = tw.a`text-sm text-blue-600 hover:underline cursor-pointer`;

const ImagesGrid = tw.div`grid grid-rows-2 gap-4`;
const TopImage = tw.img`w-full h-72 object-cover rounded-lg`;
const BottomImages = tw.div`grid grid-cols-2 gap-4`;
const Image = tw.img`w-full h-72 object-cover rounded-lg`;

export default () => {
    return (
        <Container>
            <Content>
                <ContainerGrid>
                    {/* Text Section */}
                    <TextSection>
                        <HeadingTitle style={{ textAlign: "left" }}>Recetas</HeadingTitle>
                        <Subtitle>Llevá lo nuestro a tu cocina</Subtitle>
                        <Paragraph>
                            Un espacio para los fans de lo casero.
                            <br />
                            Recetas simples, ricas y aprobadas por nuestra comunidad.
                        </Paragraph>
                        <LinksWrapper>
                            <RecipeLink
                                href="https://www.instagram.com/p/DJ7o34Dy2bA/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                TOSTADAS TIPO CHEESECAKE
                            </RecipeLink>
                            <RecipeLink
                                href="https://www.instagram.com/p/DJZScYcRpI-/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                TOSTADAS FRANCESAS
                            </RecipeLink>
                            <RecipeLink
                                href="https://www.instagram.com/p/DKki3Dmxiie/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                DESAYUNO FIT
                            </RecipeLink>
                        </LinksWrapper>
                    </TextSection>

                    {/* Images Section */}
                    <ImagesGrid>
                        <TopImage src={PanDulce} alt="Pan dulce" />
                        <BottomImages>
                            <Image src={Pan} alt="Pan" />
                            <Image src={Pepas} alt="Pepas" />
                        </BottomImages>
                    </ImagesGrid>
                </ContainerGrid>
            </Content>
        </Container>
    );
};
